import React from "react";
import { useStaticQuery, graphql } from "gatsby";
import { createSelectFilter, extractFilterOptions } from "./SelectFilter";

const Filter = createSelectFilter("Type");

export const VideoTypeFilter = (props) => {
    const options = extractFilterOptions(
        useStaticQuery(graphql`
            query videoTypes {
                filterData: allContentfulVideoType(
                    filter: { node_locale: { eq: "en-US" } }
                ) {
                    edges {
                        node {
                            label: name
                            key: contentful_id
                        }
                    }
                }
            }
        `)
    );
    return <Filter options={options} {...props} />;
};
